export const getMessage = (worker_name: string) => {
  return `${worker_name} 様

添付PDFの出退勤時間を確認して下さい。

修正箇所がある場合は、メール着後2日以内に返信して下さい。

返信なき場合は修正なしとします。
`;
};
export const getSubject = (workerName: string) => {
  return `出退勤時間の確認＞森松工業`;
};
